export async function updateDontShowAgain({ commit }, dontShowAgain) {
  commit('SET_DONT_SHOW_AGAIN', dontShowAgain);
}

export async function incrementViewCount({ commit }) {
  commit('INCREMENT_VIEW_COUNT');
}
